<template>
  <g :style="{
    transform: `translate(${x}px, ${y}px)`
  }">
    <rect :width="width/2" :height="height1" :y="height - height1 - labelHeight" fill="#E56A31" />
    <rect :width="width/2" :x="width/2" :height="height2" :y="height - height2 - labelHeight" fill="#D32E64" />
    <foreignObject :x="0" :y="height - labelHeight + 10" :width="width" :height="labelHeight - 10">
    <div xmlns="http://www.w3.org/1999/xhtml">
      <p style="font-size:8px; text-align: center; line-height:1em;">{{ item.label }}</p>
    </div>
  </foreignObject>

  <text  text-anchor="middle" fill="black" xml:space="preserve" style="white-space: pre" font-family="Poppins, Helvetica neue, Helvetica" font-size="9" letter-spacing="0em">
      <tspan :x="width*0.25" :y="height - height1 - labelHeight - 4">{{ item.point | round }}</tspan>
  </text>

  <text text-anchor="middle" fill="black" xml:space="preserve" style="white-space: pre" font-family="Poppins, Helvetica neue, Helvetica" font-size="9" letter-spacing="0em">
      <tspan :x="width*0.75" :y="height - height2 - labelHeight - 4">{{ item.scan | round }}</tspan>
  </text>
  </g>
</template>

<script>
export default {
  props:{
    item: {
      type: Object,
      default(){
        return {
          point: 100,
          scan: 100,
          label: "Behaivour name",
          pointScale: 0.5,
          scanScale: 0.5,
        }
      }
    },
    x:{
      type: Number,
      default: 0
    },
    y:{
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 40
    },
    height:{
      type: Number,
      default: 200
    }
  },
  data(){
    return {
      margin: 0,
      labelHeight: 40,
    }
  },
  computed:{
    height1(){
      return Math.round(this.item.pointScale * (this.height - this.labelHeight))
    },
    height2(){
      return Math.round(this.item.scanScale * (this.height - this.labelHeight))
    },
  },
  filters:{
    round(v){
      return Math.round(v)
    }
  }
}
</script>